import { SVGProps } from 'react'

export const InventoryIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="19"
    height="22"
    viewBox="0 0 19 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.5 3C14.43 3 14.895 3 15.2765 3.10222C16.3117 3.37962 17.1204 4.18827 17.3978 5.22354C17.5 5.60504 17.5 6.07003 17.5 7V16.2C17.5 17.8802 17.5 18.7202 17.173 19.362C16.8854 19.9265 16.4265 20.3854 15.862 20.673C15.2202 21 14.3802 21 12.7 21H6.3C4.61984 21 3.77976 21 3.13803 20.673C2.57354 20.3854 2.1146 19.9265 1.82698 19.362C1.5 18.7202 1.5 17.8802 1.5 16.2V7C1.5 6.07003 1.5 5.60504 1.60222 5.22354C1.87962 4.18827 2.68827 3.37962 3.72354 3.10222C4.10504 3 4.57003 3 5.5 3M11.5 13.3034H5.5M7.5 17.3034H5.5M13.5 9.30342H5.5M7.1 5H11.9C12.4601 5 12.7401 5 12.954 4.89101C13.1422 4.79513 13.2951 4.64215 13.391 4.45399C13.5 4.24008 13.5 3.96005 13.5 3.4V2.6C13.5 2.03995 13.5 1.75992 13.391 1.54601C13.2951 1.35785 13.1422 1.20487 12.954 1.10899C12.7401 1 12.4601 1 11.9 1H7.1C6.53995 1 6.25992 1 6.04601 1.10899C5.85785 1.20487 5.70487 1.35785 5.60899 1.54601C5.5 1.75992 5.5 2.03995 5.5 2.6V3.4C5.5 3.96005 5.5 4.24008 5.60899 4.45399C5.70487 4.64215 5.85785 4.79513 6.04601 4.89101C6.25992 5 6.53995 5 7.1 5Z"
      stroke="#475467"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
